module.exports = __webpack_public_path__ + "img/background-supplier.ddd4074a.svg";